import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLanguageKeyRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-language-key',
	path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?',
};
